import React from 'react';
import PropTypes from 'prop-types';
import GoalInfo from './GoalInfo';
import { MESSAGE } from '../../../../../constants/shared/GraphConstants';

const { ZOOM, GOAL } = MESSAGE;

const PmGraphInfo = ({ defaultGoal, customGoal, isGoalEnabled }) => (
    <div className="graph-info-container">
        {isGoalEnabled && (
            <div className="goals-container">
                <GoalInfo goal={defaultGoal} isDefaultGoal />
                <GoalInfo goal={customGoal} />
            </div>
        )}
        <div className="graph-messages">
            {isGoalEnabled && <span className="graph-custom-goal-message font-italic">{GOAL}</span>}
            <span className="graph-zoom-message font-italic">{ZOOM}</span>
        </div>
    </div>
);

PmGraphInfo.defaultProps = {
    defaultGoal: null,
    customGoal: null,
    isGoalEnabled: false,
};

PmGraphInfo.propTypes = {
    defaultGoal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    customGoal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isGoalEnabled: PropTypes.bool,
};

export default PmGraphInfo;
